import script from "./DisclaimerDesign.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisclaimerDesign.vue?vue&type=script&setup=true&lang=ts"

import "./DisclaimerDesign.vue?vue&type=style&index=0&id=6cffc996&lang=css"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QPageContainer,QCarousel,QCarouselSlide,QAvatar,QFooter,QSlideTransition,QCheckbox,QField,QSpinner,QBtn});
